module.exports = __webpack_public_path__ + "img/142,145 사회와 법률-sns마켓-신문.24de0ff5.png";